import React from 'react'

import clsx from 'clsx'

import Typography from 'components/Typography'

import styles from './Display.module.scss'

/** @type {import("./types").default} */
const Display = ({ display, subscript, variant = 'large' }) => {
  const isLarge = variant === 'large'

  return (
    <div className={clsx('Display', styles.root, styles[variant])}>
      <Typography variant={isLarge ? 'display-md' : 'display-sm'}>{display}</Typography>
      {subscript && (
        <Typography variant={isLarge ? 'body-sm' : 'body-xs'} className={styles.subscript}>
          {subscript}
        </Typography>
      )}
    </div>
  )
}

export default Display
